import { InjectionToken } from "@angular/core";

export interface FormErrorName {
  [key: string]: (...args: any[]) => string;
}

export const DEFAULT_ERRORS: FormErrorName = {
  required: () => `Este campo é obrigatório`,
  minlength: ({
    requiredLength,
    actualLength,
  }: {
    requiredLength: number;
    actualLength: number;
  }) => `Espera que tenha ${requiredLength} caracteres, mas possui ${actualLength}.`,
};

export const FORM_ERRORS = new InjectionToken("FORM_ERRORS", {
  providedIn: "root",
  factory: () => DEFAULT_ERRORS,
});
